import { downloadFile } from './NoBcp';

export const stringAvatar = name => {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name?.split(' ')[0][0]}${name?.split(' ').length > 1 ? name?.split(' ')[1][0] : ''}`,
  }
}

export const contriesList = ["Algeria", "Angola", "Argentina", "Armenia", "Australia", "Azerbaijan", "Austria",
"Bahrain", "Bangladesh", "Belarus", "Belgium", "Benin", "Bolivia", "Bosnia & Herzegovina", "Brazil", "Bulgaria", "Burkina Faso",
"Cambodia", "Cameroon", "Canada", "Caribbean", "Chad", "Chile", "China Mainland, Greater China", "Colombia", "Congo - Kinshasa", "Costa Rica", "Croatia", "Cuba", "Czechia", "Côte d’Ivoire",
"Denmark", "Dominican Republic",
"Ecuador", "Egypt", "El Salvador", "Fiji", "Finland", "France",
"Gabon", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Guatemala",
"Haiti", "Honduras", "Hong Kong SAR, Greater China", "Hungary",
"India", "Indonesia", "Israel", "Iran", "Ireland", "Israel", "Italy",
, "Japan", "Jordan", "Jamaica", "Kazakhstan", "Kenya", "KSA", "Kuwait",
"Lebanon",
"Malaysia", "Malta", "Mauritius", "Mexico", "Morocco", "Mongolia",
"Mozambique", "New Zealand", "Netherlands", "New Caledonia", "Nicaragua", "Nigeria", "North Macedonia", "Norway",
"OMAN", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Poland", "Polynesia", "Portugal",
"Puerto Rico",
"Philippines", "Qatar", "Romania", "Russia",
"Singapore", "Saudi Arabia", "Senegal", "Serbia", "South Africa", "Slovakia", "Slovenia", "South Africa", "South Korea",
"Spain", "Sri Lanka", "Sweden", "Switzerland", "Syria",
"Thailand", "Taiwan, Greater China", "Tajikistan", "Turkmenistan",
"Tunisia", "Turkey", "United Arab Emirates", "United Kingdom",
"United States", "Uruguay", "Uzbekistan", "Venezuela",
, "Vietnam", "Zambia"
]

  // check action is accept or reject and disable the button condition wise
  export const CheckActionDisable = (options, action) => {
    if (action === 'Accept') {
        return options?.disabled ? (options?.disabled) : areActionsDisabled

    } else if (action === 'Reject') {
        return options?.disabled ? (options?.disabled) : areRejectDisabled

    } else if (action === 'Edit Vendor Details') {
        return options?.disabled ? (options?.disabled) : areRejectDisabled
    } else {
        return false;
    }
}

export const stringToColor = string => {
  let hash = 0
  let i

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string?.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.substr(-2)
  }
  /* eslint-enable no-bitwise */

  return color
}


// This function retrieves the initial name of the user
export const getUserInitialsEdit = (latestObject) => {
  let nameInitialText = "";
  if (latestObject) {
    nameInitialText = latestObject?.split(' ')[0]?.[0] + (latestObject?.split(' ').length > 1 ? latestObject?.split(' ')[1]?.[0] : '')
  }
  return nameInitialText;
}

export const QA_ROLES = {
  CTAG_AG: "CTAG/AG",
  SQA: "SQA at host market",
  QA_IN_FACTORY: "QA in Factory",
  BP: "Business Partner",
  PM: "Procurement Manager",
  PS: "Procurement Specialist",
  REQUESTOR: "Requestor"
}

export const TARGET_BCP_MAP = {
  alternateSiteNewVendor: "Alternate site with new Vendor",
  alternativeSiteApprovedPlant: "Alternative site with new Vendor already approved in other plants",
  alternateSiteSameVendor: "Alternate site with same Vendor"
}



// get date in dd/mm/yyy format
export const getFormattedDate = (date) => {
  if (date) {
    const year = date?.getFullYear();

    const shortMonth = getMonthAbbreviation(1 + date.getMonth());
    console.log("shortMonth ", shortMonth)

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return day + ' ' + shortMonth + '. ' + year;
  }
  else {
    return getNotAvailableText()
  }
}

export const getMonthAbbreviation = (monthNumber) => {
  const months = {
    1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun",
    7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec"
  };
  return months[monthNumber];
}

// Get the exact name from the name;email format text

export const getPersonName = (inputNameText) => {
  let nameEmailTextArray = inputNameText?.split(/[:;]/);
  const fullName = nameEmailTextArray?.[0];
  let email = nameEmailTextArray?.[1];
  return { fullName, email }
}

export const getNotAvailableText = () => {
  return "No Data"
}

// Get the exact name from the name;email format text

export const getTargetBCPText = (targetBCPValue) => {
  return TargetBCPMap[targetBCPValue] || ""
}

export const TargetBCPMap = {
  alternateSiteSameVendor: "Alternate site with same Vendor",
  alternateSiteNewVendor: "Alternate site with new Vendor",
  alternativeSiteApprovedPlant: "Alternative site with new Vendor already approved in other plants"
};

/**
 * Filter an array of objects whose any properties contains a value
 * https://stackoverflow.com/questions/44312924/filter-array-of-objects-whose-any-properties-contains-a-value
 * @param {[*]} array
 * @param {string} string
 * @return {*}
 */
export const filterByValue = (array, string) => {
  return array.length > 0
    ? array.filter(o => Object.keys(o).some(k => o[k] && o[k].toString().toLowerCase().includes(string.toLowerCase())))
    : []
}

/**
 * Util class to download and cache content for files RF code, stored remotely
 */
export class RFDocument {

  /**
   * @param {Object} documentObject
   */
  constructor(documentObject) {

    /**
     * @type {string}
     */
    this.fileID = documentObject.fileID;

    /**
     * @type {string}
     */
    this.fileName = documentObject.fileName.trim();

    /**
     * @type {string}
     */
    this.fileExt = documentObject.fileExt.trim();

    /**
     * @type {?string}
     */
    this.dataUrl = null;
  }

  /**
   * Return the data URL for download or in-browser display
   * @return {Promise<string>}
   */
  async fetchDataUrl() {
    if (this.dataUrl !== null) {
      return this.dataUrl;
    }
    const result = await downloadFile(this.fileID, this.fileName, this.fileExt);
    // TODO catch error
    this.dataUrl = `data:${this.getMimeType()};base64,${result['fileContents']}`;
    return this.dataUrl;
  }

  /**
   * @return {string}
   */
  getMimeType() {
    return supportedMimeTypes[this.fileExt] || 'application/octet-stream';
  }

  /**
   * @return {string}
   */
  getFullName() {
    return `${this.fileName}.${this.fileExt}`;
  }

}

/**
 * Mapping between file extension and mimetypes supported for in-browser display
 *
 * @type {Object<string, string>}
 */
export const supportedMimeTypes = {
  'pdf': 'application/pdf',
  'png': 'image/png',
  'jpg': 'image/jpg',
  'jpeg': 'image/jpg',
}

/**
 * @param {string} dataUrl
 * @param {string=} name
 */
export const applyDownload = (dataUrl, name) => {
  const element = document.createElement('a');
  element.setAttribute('href', dataUrl);
  element.setAttribute('download', name || 'downloaded_file');
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
